import { Injectable } from '@angular/core';
import { PatientTableRow } from '../patient-search/patient-search.component';
import { PatientDetails } from '../models/patient-details.model';

type SearchType = 'patients' | 'teammates' | 'providers' | 'facility';

export interface SearchState {
  searchType: SearchType;
  hasSearched: boolean;
  searchResults: PatientTableRow[];
  isSingleResult: boolean;
  detailedPatient: PatientDetails | null;
  lastSearchQuery?: {
    query: string;
    type: string;
    firstName?: string;
    lastName?: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class SearchStateService {
  private state: SearchState = {
    searchType: 'patients',
    hasSearched: false,
    searchResults: [],
    isSingleResult: false,
    detailedPatient: null
  };

  getState(): SearchState {
    return { ...this.state };
  }

  setState(newState: Partial<SearchState>): void {
    this.state = { ...this.state, ...newState };
  }

  setSearchResults(results: PatientTableRow[]): void {
    this.state.searchResults = results;
    this.state.hasSearched = true;
    this.state.isSingleResult = false;
  }

  setDetailedPatient(patient: PatientDetails | null): void {
    this.state.detailedPatient = patient;
    this.state.hasSearched = true;
    this.state.isSingleResult = patient !== null;
  }

  setLastSearchQuery(query: SearchState['lastSearchQuery']): void {
    this.state.lastSearchQuery = query;
  }

  clearSearch(): void {
    this.state = {
      searchType: this.state.searchType,
      hasSearched: false,
      searchResults: [],
      isSingleResult: false,
      detailedPatient: null
    };
  }

  hasResults(): boolean {
    return this.state.hasSearched && (this.state.searchResults.length > 0 || this.state.isSingleResult);
  }
}
